import { motion } from "framer-motion";

const recipes = [
  {
    id: 1,
    title: "Tacos al Pastor con Macha",
    description: "Cerdo al pastor bañado con nuestra Salsa Macha para un toque ahumado y con nuez.",
    image: "https://images.pexels.com/photos/5201109/pexels-photo-5201109.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    time: "45 min",
    difficulty: "Intermedio",
  },
  {
    id: 2,
    title: "Tostadas de Tinga con Chapultepín",
    description: "Tinga de pollo jugosa y ahumada elevada con nuestra salsa Chapultepín para un sabor único e inigualable.",
    image: "https://images.unsplash.com/photo-1633271306841-0e5cce5d794f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHx0b3N0YWRhc3xlbnwwfHx8fDE3NzM3NzAwNTB8MA&ixlib=rb-4.1.0&q=85",
    time: "45 min",
    difficulty: "Intermedio",
  },
  {
    id: 3,
    title: "Aguachile Habanero",
    description: "Camarones frescos en un baño cítrico de Habanero Dorado con pepino y cebolla morada.",
    image: "https://images.unsplash.com/photo-1565686481561-d8ceaa689e01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxzaHJpbXAlMjBkaXNoJTIwZGFyayUyMHBsYXRlJTIwbW9vZHl8ZW58MHx8fHwxNzczNzc0MzE2fDA&ixlib=rb-4.1.0&q=85",
    time: "25 min",
    difficulty: "Fácil",
  },
  {
    id: 4,
    title: "Quesadilla Verde Ancestral",
    description: "Queso Oaxaca derretido entre tortillas hechas a mano, bañadas con Verde Ancestral.",
    image: "https://images.pexels.com/photos/11897530/pexels-photo-11897530.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    time: "20 min",
    difficulty: "Fácil",
  },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 25 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export default function RecipeGallery() {
  return (
    <section
      id="recipes"
      data-testid="recipes-section"
      className="relative py-24 md:py-32"
      style={{ backgroundColor: "#262626" }}
    >
      {/* Noise overlay */}
      <div
        className="absolute inset-0 opacity-[0.02] pointer-events-none"
        style={{ backgroundImage: "url('https://grainy-gradients.vercel.app/noise.svg')" }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.4 }}
          className="mb-16"
        >
          <p className="text-sm uppercase tracking-[0.3em] text-[#D4AF37] mb-4">
            De Nuestra Cocina
          </p>
          <h2
            className="text-4xl md:text-5xl font-bold text-[#F5F5F0] tracking-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Donde la salsa es <br />
            <span className="text-[#E07A5F]">la protagonista</span>
          </h2>
        </motion.div>

        {/* Recipe grid - asymmetric layout */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          {recipes.map((recipe, i) => (
            <motion.div
              key={recipe.id}
              variants={cardVariants}
              className={`group relative overflow-hidden rounded-xl cursor-pointer ${
                i === 0 ? "md:row-span-2" : ""
              }`}
              data-testid={`recipe-card-${recipe.id}`}
            >
              <div className={`relative ${i === 0 ? "h-80 md:h-full" : "h-80"} overflow-hidden`}>
                <img
                  src={recipe.image}
                  alt={recipe.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                {/* Dark overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A] via-[#1A1A1A]/30 to-transparent" />

                {/* Content overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-[10px] uppercase tracking-widest text-[#D4AF37] border border-[#D4AF37]/40 px-2 py-1">
                      {recipe.difficulty}
                    </span>
                    <span className="text-xs text-[#A3A3A3]">{recipe.time}</span>
                  </div>
                  <h3
                    className="text-xl md:text-2xl font-semibold text-[#F5F5F0] mb-2"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {recipe.title}
                  </h3>
                  <p className="text-sm text-[#A3A3A3] leading-relaxed line-clamp-2 max-w-sm">
                    {recipe.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
